export default __webpack_public_path__ + "static/media/energisingchocolate-wide@3x.85da12e6.jpg";